import React from "react";
import { DateFilter } from "../utils/date-utils";

interface DateFilterTabsProps {
  selectedFilter: DateFilter;
  onFilterChange: (filter: DateFilter) => void;
  className?: string;
}

const DateFilterTabs: React.FC<DateFilterTabsProps> = ({
  selectedFilter,
  onFilterChange,
  className = "",
}) => {
  const filters = [
    { value: DateFilter.All, label: "All" },
    { value: DateFilter.Today, label: "Today" },
    { value: DateFilter.ThisWeek, label: "This Week" },
    { value: DateFilter.ThisMonth, label: "This Month" },
  ];

  return (
    <div className={`flex max-w-[698px] flex-wrap gap-4 ${className}`.trim()}>
      {filters.map((filter) => (
        <label key={filter.value} className="flex cursor-pointer">
          <input
            type="radio"
            name="dateFilter"
            value={filter.value}
            className="peer hidden"
            checked={selectedFilter === filter.value}
            onChange={() => onFilterChange(filter.value)}
          />
          <span className="checkbox-group-item py-0">{filter.label}</span>
        </label>
      ))}
    </div>
  );
};

export default DateFilterTabs;
